import React, { Component } from 'react';
import fetchJsonp from 'fetch-jsonp';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import AMPPage from '../AMPPage';
import AMPPageHeader from '../AMPPageHeader';
import AMPPageSection from '../AMPPageSection';
import Img from '../Img';
import OutboundLink from '../OutboundLink';
import styles from './styles.sass';

const IMG_PREFIX = 'https://d12xoj7p9moygp.cloudfront.net/images/';

class AMPJobsPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      jobs: [],
    };
  }

  componentDidMount() {
    fetchJobsFromVendor().then(jobs => {
      this.setState({ jobs });
    });
  }

  render() {
    const { jobs } = this.state;
    const isAmp = this.props.context && this.props.context.isAmpRoute;

    return (
      <AMPPage isAmpRoute={isAmp}>
        <AMPPageHeader
          title="Work at Anchor"
          subtitle="Help create the future of audio in New York City!"
        />
        <AMPPageSection color="gray">
          <span className={styles.tagline}>
            Our mission is to democratize audio. Anchor makes podcasting
            accessible to everyone and modernizes the medium by making it
            shareable, interactive, and easy to create and consume.
          </span>
        </AMPPageSection>
        <AMPPageSection id="Who-We-Are" className={styles.whoWeAre}>
          <Row>
            <Col xs={12} sm={6}>
              <h2>Who we are</h2>
              <div className={styles.hardworking}>
                <p>
                  We’re a hard-working team of people who are obsessed with
                  reinventing audio.
                </p>
              </div>
            </Col>
            <Col xs={12} sm={6}>
              <div className={styles.teamPhoto}>
                <Img
                  isAmp={isAmp}
                  alt="Anchor team"
                  src={`${IMG_PREFIX}jobs-team.png`}
                  withRetina
                  width={365}
                  height={318}
                  layout="responsive"
                />
              </div>
            </Col>
          </Row>
          <p>We’re also:</p>
          <h3>Passionate</h3>
          <p>
            People who work at Anchor are&nbsp;
            <strong>passionate</strong>
            &nbsp;- not just about their jobs or audio or helping people get
            their voices heard, but about all kinds of things. You might be a
            musician, or have an interesting side project, or volunteer outside
            of work. Whatever it is, we all care deeply about our shared and
            personal missions and the ways we impact the world around us.
          </p>
          <h3>Collaborative</h3>
          <p>
            We’ve built our company culture around &nbsp;
            <strong>collaborative</strong>
            &nbsp; people. We expect everyone to work together, be willing to
            help with projects outside of their comfort zones - whether that’s
            learning a new skill, brainstorming a wacky idea, or helping to
            build furniture - and have the confidence to ask for help when it’s
            needed.
          </p>
          <h3>Creative</h3>
          <p>
            The members of Team Anchor are &nbsp;
            <strong>creative</strong>, both professionally and personally. We
            laugh a lot. We’re always willing to humor strange conversations,
            because they lead to the best ideas. We all bring our unique life
            experiences to work with us and use them to guide us in building a
            platform that delights a huge variety of people constantly. And of
            course, we’re all constantly launching our own goofy podcasts.
          </p>
          <h3>Not assholes</h3>
          <p>
            Most importantly, everyone at Anchor is &nbsp;
            <strong>not an asshole</strong>. We know that nothing matters more
            than being kind to our coworkers and ourselves. We pride ourselves
            on making connections with the very awesome people using our product
            every day, and remember that everything we do, we do for them. We go
            out of our way to help our coworkers, whether that’s by pitching in
            on a project or just offering positivity when it’s needed.
          </p>
        </AMPPageSection>
        <AMPPageSection
          color="gray"
          id="Working-At-Anchor"
          className={styles.benefits}
        >
          <Row>
            <Col className={`col-sm-5 hidden-xs ${styles.workingImg}`}>
              <Img
                isAmp={isAmp}
                alt="Anchor team photos"
                src={`${IMG_PREFIX}jobs-office.png`}
                withRetina
                width={395}
                height={520}
                layout="fixed"
              />
            </Col>
            <Col xs={12} sm={7}>
              <h2>Working at Anchor</h2>
              <p>A few of the many benefits:</p>
              <ul>
                <li>🎤 Work on something amazing</li>
                <li>🔧 Solve real, challenging problems</li>
                <li>🌴 Flexible vacation policy</li>
                <li>🏥 Employer-paid benefits</li>
                <li>💰 Competitive salaries</li>
                <li>💸 Meaningful equity</li>
                <li>👯 Collaborative, fast-paced environment</li>
              </ul>
            </Col>
          </Row>
        </AMPPageSection>
        <AMPPageSection id="Open-Positions" className={styles.positions}>
          <Row>
            <Col xs={12} sm={7}>
              <h2>Open positions</h2>
              <p>All positions are full time and on site in New York City.</p>
              <ul>
                {jobs.map(job => (
                  <li key={job.id}>
                    <OutboundLink newWindow to={job.hostedUrl}>
                      {job.text}
                    </OutboundLink>
                  </li>
                ))}
              </ul>
            </Col>
            <Col xsHidden sm={5}>
              <Img
                isAmp={isAmp}
                alt="Anchor team positions"
                src={`${IMG_PREFIX}jobs-team-polaroids.png`}
                withRetina
                width={453}
                height={570}
                layout="fixed"
              />
            </Col>
          </Row>
        </AMPPageSection>
        <AMPPageSection color="gray">
          <h2>Don’t see your position listed, but love what we’re doing?</h2>
          <p>
            Email us anyway, and tell us why you’d be a great fit for Anchor:{' '}
            <a href="mailto:jobs@anchor.fm">jobs@anchor.fm</a>
          </p>
        </AMPPageSection>
      </AMPPage>
    );
  }
}

function fetchJobsFromVendor() {
  return new Promise((resolve, reject) =>
    fetch('https://api.lever.co/v0/postings/anchor?mode=json')
      .then(resolve)
      .catch(reject)
  ).then(response => {
    const { status } = response;
    if (status === 200) {
      return response.json();
    }
    return null;
  });
}

export default AMPJobsPage;
